import React from "react";

const RequiredMark = () => {
    // 必須項目のマークをコンポーネント化
    return <span className='text-danger'> * </span>;
};

export default RequiredMark;
